import React, { CSSProperties, useState } from 'react';

// eslint-disable-next-line import/no-named-default
import { default as i18n, default as i18next } from 'i18next';
import classNames from 'classnames';

import { ReactComponent as CheckIcon } from 'assets/icons/checked.svg';
import deFlag from 'assets/germany-flag.png';
import ukFlag from 'assets/uk-flag.png';
import eeFlag from 'assets/estonia-flag.png';
import DropDown from 'components/DropDown/DropDown';
import ArrowDown from 'components/Icons/ArrowDown';

import 'components/Modal/Modal.scoped.scss';
import './LanguageDropDown.scoped.scss';

interface Props {
  children?: React.ReactNode;
  boxStyle?: CSSProperties;
}

const LanguageDropDown: React.FC<Props> = () => {
  const lang = i18n.language;
  const [checkedLang, setCheckedLang] = useState(lang);
  const [modalOpened, setModalOpened] = useState(true);

  const handleLanguage = value => {
    setCheckedLang(value);
  };

  const handleChangeLanguage = value => {
    handleLanguage(value);
    i18next.changeLanguage(value);
    window.localStorage.setItem('lang', value);
  };

  const Icon = () => (
    <div className="avatar-dropdown">
      {checkedLang === 'de' && (
        <div className="flag-container" onClick={() => handleChangeLanguage('de')}>
          <img src={deFlag} alt="DE flag icon" />
          <p>
            German{' '}
            {checkedLang === 'de' && (
              <div className={classNames('arrow', { up: modalOpened })}>
                <ArrowDown />
              </div>
            )}{' '}
          </p>
        </div>
      )}

      {checkedLang === 'en' && (
        <div className="flag-container" onClick={() => handleChangeLanguage('en')}>
          <img src={ukFlag} alt="DE flag icon" />
          <p>
            English{' '}
            {checkedLang === 'en' && (
              <div className={classNames('arrow', { up: modalOpened })}>
                <ArrowDown />
              </div>
            )}{' '}
          </p>
        </div>
      )}

      {checkedLang === 'ee' && (
        <div className="flag-container" onClick={() => handleChangeLanguage('ee')}>
          <img src={eeFlag} alt="EE flag icon" />
          <p>
            Estonia{' '}
            {checkedLang === 'ee' && (
              <div className={classNames('arrow', { up: modalOpened })}>
                <ArrowDown />
              </div>
            )}{' '}
          </p>
        </div>
      )}
    </div>
  );

  return (
    <div className="avatar-container pointer" onClick={() => setModalOpened(!modalOpened)}>
      <DropDown icon={Icon()} boxStyle={{ position: 'relative' }}>
        <div className="two-dropdowns">
          <div className="dropdown-container">
            <div className="flag-container" onClick={() => handleChangeLanguage('en')}>
              <img src={ukFlag} className="flag-img" />
              <p>English {checkedLang === 'en' && <CheckIcon className="check-icon" />}</p>
            </div>
            <div className="flag-container" onClick={() => handleChangeLanguage('de')}>
              <img src={deFlag} className="flag-img" />
              <p>German {checkedLang === 'de' && <CheckIcon className="check-icon" />} </p>
            </div>

            <div className="flag-container" onClick={() => handleChangeLanguage('ee')}>
              <img src={eeFlag} className="flag-img" />
              <p>Estonia {checkedLang === 'ee' && <CheckIcon className="check-icon" />} </p>
            </div>
            <div />
          </div>
        </div>
      </DropDown>
    </div>
  );
};

export default LanguageDropDown;
